import Icon from "ol/style/Icon";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import { SERVER } from "./defaults";
import { createTextStyle, getScale } from "./helpers";
import { myDom } from "./my-dom";

const colorMosi = [];
colorMosi[1] = "#ffd811bf";
colorMosi[2] = "#a260c2bf";
colorMosi[3] = "#ffffffff"; //'#fa462fbf';
colorMosi[4] = "#7cad33bf";

const colorMosiOutline = [];
colorMosiOutline[1] = "#969696bf";
colorMosiOutline[2] = "#969696bf";
colorMosiOutline[3] = "#da2600bf"; //'#fa462fbf';
colorMosiOutline[4] = "#969696bf";

const lineDashMosi = [];
lineDashMosi[1] = [1];
lineDashMosi[2] = [1];
lineDashMosi[3] = [3, 5];
lineDashMosi[4] = [1];

const styles = {
  multipoint: (feature, resolution) => {
    const icon =
      SERVER +
      "/images/MOSI_multipoint" +
      feature.get("id_macrocategoria") +
      ".svg";
    const anchor = [0.5, 0.5];
    const scale = getScale(resolution) * 1.5;

    const style = new Style({
      image: new Icon({
        anchor: anchor,
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: scale,
        src: icon,
      }),
    });

    return [style];
  },

  concessioni: (feature, resolution) => {
    let iconName = "";

    if (feature.get("id").indexOf("concessioni_estere_gna_centroids.fid-") > -1)
      iconName = "concessioni_estere_pt.svg";
    else iconName = "concessioni_pt.svg";

    const icon = SERVER + "/images/" + iconName;
    const anchor = [0.5, 0.5];
    const scale = getScale(resolution) * 1.5;

    const style = new Style({
      image: new Icon({
        anchor: anchor,
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: scale,
        src: icon,
      }),
    });

    return [style];
  },

  iccd: (feature, resolution) => {
    const icon = SERVER + "/images/catalogo_pt.svg";
    const anchor = [0.5, 0.5];
    const scale = 0.03;

    const style = new Style({
      image: new Icon({
        anchor: anchor,
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: scale,
        src: icon,
      }),
    });

    return [style];
  },

  tess: (feature, resolution) => {
    const icon = SERVER + "/images/tess_pt.svg";
    const anchor = [0.5, 0.5];
    const scale = 0.03;

    const style = new Style({
      image: new Icon({
        anchor: anchor,
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: scale,
        src: icon,
      }),
    });

    return [style];
  },

  censimento: (feature, resolution) => {
    const icon = SERVER + "/images/censimenti_pt.svg";
    const anchor = [0.5, 0.5];
    const scale = getScale(resolution);

    const style = new Style({
      image: new Icon({
        anchor: anchor,
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: scale,
        src: icon,
      }),
    });

    return [style];
  },

  multipolygon: (feature, resolution) => {
    const icon =
      SERVER +
      "/images/MOSI_multipoint" +
      feature.get("id_macrocategoria") +
      ".svg";
    const anchor = [0.5, 0.5];
    const scale = getScale(resolution) * 1.5;

    const style = new Style({
      stroke: new Stroke({
        color: colorMosiOutline[feature.get("id_macrocategoria")],
        lineDash: lineDashMosi[feature.get("id_macrocategoria")],
        width: 2,
      }),
      fill: new Fill({
        color: colorMosi[feature.get("id_macrocategoria")],
      }),
    });

    return [style];
  },
  multiline: (feature, resolution) => {
    let width = 3;
    let styleDef2 = new Style({});
    if (feature.get("id_macrocategoria") == 3) {
      width = width - 2;
      styleDef2 = new Style({
        stroke: new Stroke({
          color: colorMosiOutline[feature.get("id_macrocategoria")],
          lineDash: lineDashMosi[feature.get("id_macrocategoria")],
          width: width + 2,
        }),
      });
    }

    if (resolution < 25) width = 6;
    if (resolution < 5) width = 10;

    const style = new Style({
      stroke: new Stroke({
        color: colorMosi[feature.get("id_macrocategoria")],
        width: width,
      }),
    });

    return [styleDef2, style];
  },

  r_multiline: (feature, resolution) => {
    // let width = 3;
    // let styleDef2 = new Style({});
    // if (feature.get("id_macrocategoria") == 3) {
    //     width = width - 2;
    //     styleDef2 = new Style({
    //         stroke: new Stroke({
    //             color: colorMosiOutline[feature.get("id_macrocategoria")],
    //             lineDash: lineDashMosi[feature.get("id_macrocategoria")],
    //             width: width + 2,
    //         }),
    //     });
    // }

    // if (resolution < 25) width = 6;
    // if (resolution < 5) width = 10;

    const style = new Style({
      stroke: new Stroke({
        color: "rgba(185, 185, 185, 0.9)",
        lineDash: [3, 5],
        width: 3,
      }),
    });

    return [style];
  },

  r_multipolygon: (feature, resolution) => {
    const style = new Style({
      stroke: new Stroke({
        color: "rgba(185, 185, 185, 0.9)",
        lineDash: [3, 5],
        width: 1.5,
      }),
      fill: new Fill({
        color: "rgba(185, 185, 185, 0.15)",
      }),
    });

    return [style];
  },

  mopr: (feature, resolution) => {
    const style = new Style({
      stroke: new Stroke({
        color: "rgba(150, 150, 250, 0.7)",
        lineDash: [0.5, 5],
        width: 1.5,
      }),
      fill: new Fill({
        color: "rgba(52, 52, 172, 0.15)",
      }),
      text: createTextStyle(feature, resolution, myDom.polygons),
    });

    return [style];
  },
};

export { styles };
